import { SurveyPreviewAnswerWithValidation } from '@surveycake/logic-engine';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { handleEngineValidation } from 'app/modules/survey';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { useOnSubmit } from './useOnSubmit';

interface PreviewAnswerData
  extends Omit<SurveyPreviewAnswerWithValidation, 'validation'> {}

export function usePreviewAnswer(setOpen: Dispatch<SetStateAction<boolean>>) {
  const [data, setData] = useState({} as PreviewAnswerData);
  const engine = useEngineInstance();
  const previewAnswer = useCallback(() => {
    const result = engine.getPreviewAnswer();

    if (!result) {
      return;
    }

    const { validation, editable, preview } = result;
    handleEngineValidation(validation, () => {
      setOpen(true);
      setData({ editable, preview });
    });
  }, [engine, setOpen]);
  const { onSubmit, disabled } = useOnSubmit(previewAnswer);

  return [onSubmit, disabled, data] as [() => void, boolean, PreviewAnswerData];
}
